// Клиентский разбор GPX для импорта в редактор маршрутов - зеркалит
// backend/app/routes/geometry.py::parse_gpx_payload (trkpt -> точки трека,
// wpt -> вейпоинты), но своими средствами (DOMParser), без серверного
// круговорота: редактору нужен только предпросмотр перед сохранением,
// финальная геометрия всё равно проходит через тот же бэкенд-пайплайн
// (DEM/сглаживание/ресэмплинг) при POST /routes.
import type { GpxImportWaypoint } from "../composables/useRouteEditor";

export interface ParsedGpx {
  points: [number, number][]; // [lon, lat]
  waypoints: GpxImportWaypoint[];
}

const text = (el: Element | null): string | null => {
  const value = el?.textContent?.trim();
  return value ? value : null;
};

export function parseGpxText(xml: string): ParsedGpx {
  const doc = new DOMParser().parseFromString(xml, "application/xml");
  if (doc.querySelector("parsererror")) {
    throw new Error("Invalid GPX file");
  }

  const points: [number, number][] = [];
  for (const trkpt of Array.from(doc.querySelectorAll("trk trkseg trkpt"))) {
    const lat = parseFloat(trkpt.getAttribute("lat") || "");
    const lon = parseFloat(trkpt.getAttribute("lon") || "");
    if (Number.isFinite(lat) && Number.isFinite(lon)) points.push([lon, lat]);
  }
  if (!points.length) {
    throw new Error("GPX has no track points");
  }

  const waypoints: GpxImportWaypoint[] = [];
  Array.from(doc.querySelectorAll("wpt")).forEach((wpt, index) => {
    const lat = parseFloat(wpt.getAttribute("lat") || "");
    const lon = parseFloat(wpt.getAttribute("lon") || "");
    if (!Number.isFinite(lat) || !Number.isFinite(lon)) return;
    waypoints.push({
      name: text(wpt.querySelector("name")) || `Точка ${index + 1}`,
      description: text(wpt.querySelector("desc")) || text(wpt.querySelector("cmt")),
      poi_type: text(wpt.querySelector("type")),
      latitude: lat,
      longitude: lon,
    });
  });

  return { points, waypoints };
}

export function readFileAsText(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result || ""));
    reader.onerror = () => reject(reader.error || new Error("Failed to read file"));
    reader.readAsText(file);
  });
}
